import PortalIdParser from 'PortalIdParser';
export const getDatasetsUpgradeUrl = () => `/upgrade/${PortalIdParser.get()}/datasets`;
export const getUpgradeUrl = () => `/browse/${PortalIdParser.get()}/upgrade/reporting`;
export const getManageDashboardsUrl = () => `/dashboard-list/${PortalIdParser.get()}`;
export const getManageReportsUrl = () => `/reports-list/${PortalIdParser.get()}`;